import { createClient } from '@supabase/supabase-js';
import { validateEnvironmentVariables } from './validation';
import { isMockModeEnabled, mockSupabaseClient } from './mockMode';

// Create the supabase client based on mode
let supabaseClient;

if (isMockModeEnabled()) {
  console.log('🚀 Running in Mock Mode - No database required!');
  console.log('Demo credentials: demo@neurocademy.app / demo123');
  supabaseClient = mockSupabaseClient;
} else {
  // Validate environment variables on app startup
  const envValidation = validateEnvironmentVariables();
  if (!envValidation.isValid) {
    console.error('❌ Missing environment variables:', envValidation.missing);
    console.log('💡 To run without a database, set VITE_MOCK_MODE=true in your .env file');
    throw new Error(`Missing required environment variables: ${envValidation.missing.join(', ')}`);
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  // Validate URL format for additional security
  try {
    new URL(supabaseUrl);
  } catch {
    throw new Error('VITE_SUPABASE_URL is not a valid URL');
  }

  supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    },
    db: {
      schema: 'public'
    }
  });
}

export const supabase = supabaseClient;

// Existing Database type remains the same...
export type Database = {
  // ... (entire existing type definition)
};